import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { Auth0Provider } from "@auth0/auth0-react";
import { store } from "./store";
import { env } from "./config";
import "./assets/css/font/font-face.css";
import "./assets/css/font/globals.css";
import "./assets/css/index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Toaster } from "react-hot-toast";

const rootElement = document.getElementById("root");

if (!rootElement) throw new Error("Failed to find the root element");
const root = ReactDOM.createRoot(rootElement);

const auth0Domain = env.auth0Domain;
const auth0ClientId = env.auth0ClientId;
const auth0Audience = env.auth0Audience;

if (!auth0Domain) throw new Error("Failed to find the REACT_APP_AUTH0_DOMAIN");
if (!auth0ClientId)
  throw new Error("Failed to find the REACT_APP_AUTH0_CLIENT_ID");

root.render(
  <Provider store={store}>
    <Auth0Provider
      domain={auth0Domain}
      clientId={auth0ClientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: auth0Audience,
      }}
    >
      <App />
      <Toaster />
    </Auth0Provider>
  </Provider>
);
